(ns frontend.view.modals.pre-exit-check.view
  (:require
   [common.localization :as loc]
   [common.schema.entities.pre-exit-check :as pre-exit-check]
   [common.util :as cu]
   [frontend.actions.entity :as entity-actions]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [ui.components.modal.view :as modal]
   [ui.editors.labelled-input.view :as labelled-input]))

(defonce modal-key :pre-exit-check-modal)

(defn view-body
  [{:keys [state]}]
  (let [status (:pre-exit-check/status @state)
        status-options pre-exit-check/status-options]
    [:div
     [labelled-input/view
      {:label       (loc/tr :pre-exit-check/status)
       :editor-type :editor.type/select
       :value       (->> status-options
                         (cu/filter-by :value status)
                         (first))
       :options     status-options
       :on-change   (fn [v]
                      (swap! state assoc :pre-exit-check/status v))}]

     [labelled-input/view
      {:value     (:pre-exit-check/checked-on @state)
       :label     (loc/tr :pre-exit-check/checked-on)
       :data-type :data.type/date
       :on-change (fn [v]
                    (swap! state assoc :pre-exit-check/checked-on v))}]

     (when (= :pre-exit-check.status/conditionally-approved status)
       [labelled-input/view
        {:data-type :data.type/text-simple
         :value     (:pre-exit-check/conditions @state)
         :label     (loc/tr :pre-exit-check/conditions)
         :on-change (fn [v]
                      (swap! state assoc :pre-exit-check/conditions v))}])

     [labelled-input/view
      {:data-type :data.type/text-simple
       :value     (:pre-exit-check/note @state)
       :label     (loc/tr :pre-exit-check/note)
       :on-change (fn [v]
                    (swap! state assoc :pre-exit-check/note v))}]]))

(defn footer-view
  [{:keys [state init-state attribute entity-id on-close! read-only?]}]
  (let [no-updates? (->> [:pre-exit-check/status
                          :pre-exit-check/checked-on
                          :pre-exit-check/conditions
                          :pre-exit-check/note]
                         (remove (fn [attr]
                                   (= (get @state attr)
                                      (get init-state attr))))
                         (empty?))]
    [:<>
     [modal/left-cancel-only on-close! nil]
     [modal/right-single-button
      nil
      (or no-updates? read-only?)
      (fn []
        (let [pre-exit-check (select-keys @state
                                          [:pre-exit-check/status
                                           :pre-exit-check/checked-on
                                           :pre-exit-check/conditions
                                           :pre-exit-check/note])
              pre-exit-check-changes (assoc
                                      pre-exit-check
                                      :pre-exit-check/conditions
                                      (if (= :pre-exit-check.status/conditionally-approved
                                             (:pre-exit-check/status pre-exit-check))
                                        (:pre-exit-check/conditions pre-exit-check)
                                        nil))
              pre-exit-check-id (-> entity-id
                                    session/get-entity
                                    (get attribute))]
          (if pre-exit-check-id
            (entity-actions/*->entity-update!
             pre-exit-check-id
             pre-exit-check-changes
             on-close!
             (fn []))
            (entity-actions/*->create
             (assoc pre-exit-check-changes :entity/type :entity.type/pre-exit-check)
             (fn [resp]
               (let [pre-exit-check-id (-> resp
                                           :body
                                           :db/id)]
                 (entity-actions/*->field-update!
                  entity-id
                  attribute
                  pre-exit-check-id
                  on-close!
                  (fn []))))
             (fn [e] (logging/error "Could not create pre-exit-check" e pre-exit-check))))))
      (loc/tr :submit)
      nil]]))

(defn view
  [{:keys [state props]}]
  (let [{:keys [start-state]} props]
    (swap! state (fn [prev-state] (if (nil? prev-state) start-state prev-state)))
    (fn [{:keys [shown? close-modal! props topmost?]}]
      (let [{:keys [attribute entity-id start-state read-only?]} props]
        [modal/view
         {:visible?     (and shown? topmost?)
          :hide!        close-modal!
          :backdrop     "static"
          :success-text (loc/tr :success-guest-invited)
          :on-close!    close-modal!}
         (loc/tr attribute)
         [view-body (assoc props :state state)]
         [footer-view
          {:state      state
           :init-state start-state
           :attribute  attribute
           :entity-id  entity-id
           :read-only? read-only?
           :on-close!  close-modal!}]]))))
